import { AnyAction } from 'redux';
import { SponsorBanner } from '@synergy/models';

import {
    SPONSOR_BANNER_DETAIL_CREATE,
    SPONSOR_BANNER_DETAIL_ERROR,
    SPONSOR_BANNER_DETAIL_FETCH,
    SPONSOR_BANNER_DETAIL_RECEIVE,
    SPONSOR_BANNER_DETAIL_RESET,
    SPONSOR_BANNER_DETAIL_UPDATE,
} from './sponsor-banner-detail-actions';

export interface SponsorBannerDetailReducerState {
    sponsorBanner: SponsorBanner | null;
    requesting: boolean;
}

const initialSponsorBannerListReducerState: SponsorBannerDetailReducerState = {
    sponsorBanner: null,
    requesting: false,
};

export const sponsorBannerDetailReducer = (
    state: SponsorBannerDetailReducerState = initialSponsorBannerListReducerState,
    action: AnyAction
): SponsorBannerDetailReducerState => {
    switch (action.type) {
        case SPONSOR_BANNER_DETAIL_RESET: {
            return {
                ...state,
                sponsorBanner: null,
            };
        }

        case SPONSOR_BANNER_DETAIL_FETCH:
        case SPONSOR_BANNER_DETAIL_CREATE:
        case SPONSOR_BANNER_DETAIL_UPDATE: {
            return {
                ...state,
                requesting: true,
            };
        }

        case SPONSOR_BANNER_DETAIL_RECEIVE: {
            return {
                ...state,
                requesting: false,
                sponsorBanner: action['sponsorBanner'],
            };
        }

        case SPONSOR_BANNER_DETAIL_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
